module.exports = __webpack_public_path__ + "static/media/Eyes_black.a7054598.svg";